import { render, staticRenderFns } from "./DataCollection.vue?vue&type=template&id=4e5b5d43&"
import script from "./DataCollection.vue?vue&type=script&lang=js&"
export * from "./DataCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports